import React from "react";

export interface DialogPresentationContextValue {
  /** True when the hosting dialog is fullscreen (e.g. widescreen TV presentation). */
  isFullscreen: boolean;
}

const defaultValue: DialogPresentationContextValue = {
  isFullscreen: false,
};

const DialogPresentationContext = React.createContext<DialogPresentationContextValue>(defaultValue);

export default DialogPresentationContext;
